// extracted by mini-css-extract-plugin
module.exports = {"ctaMargin":"VTC_ctaMargin__p_DQo"};